module.exports = __webpack_public_path__ + "img/cornershop.7cc8b7b6.jpeg";